import AcceleratorDoc from "../../models/AcceleratorDoc";
import API from "../../models/API";
import { PageSectionData } from "../../models/matchers/PageSection";
import { Section } from "../../models/matchers/Section";
import Span, { SpanData } from "../../models/Span";

export { SectionExtractor };

/**
 * Class used to determine what Spans lie within a section of the Page.
 */
class SectionExtractor {
  pageIndex: number;
  section: Section;
  constructor(pageIndex: number, section: Section) {
    this.pageIndex = pageIndex;
    this.section = section;
  }

  async extract(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<{ spans: Span[]; boundingBox: PageSectionData } | undefined> {
    if (!acceleratorDoc.getPage(this.pageIndex)) {
      return undefined;
    }
    const response = await API.post(
      "/v0/spans",
      {
        batchInstanceUuid: acceleratorDoc.storeId.batchInstanceUuid,
        pageId: acceleratorDoc.getPage(this.pageIndex)!.externalPageIdentifier,
      },
      this.section,
    )
      .then((response) => response.json() as Promise<SectionExtractorReturn>)
      .then((resp: SectionExtractorReturn) => {
        return {
          spans: resp.spans.map((s) => new Span(s)),
          boundingBox: resp.boundingBox,
        };
      })
      .catch(() => {
        return undefined;
      });

    if (!response) {
      console.warn(
        `Error calling API to extract with Section ${this.section.getSectionId()}`,
      );
    }
    if (response && !response!.spans.length) {
      console.warn(
        `Could not get Spans under section with Section ${this.section.getSectionId()}`,
      );
    }
    return response;
  }
}

type SectionExtractorReturn = {
  spans: SpanData[];
  boundingBox: PageSectionData;
};
